<template>
  <div class="extra-right-legend">
    <div class="extra">
      <div class="total-title">{{ t('bi.total') }}</div>
      <div class="total">{{ totalValue.toLocaleString() }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

//libs
import { useI18n } from 'vue-i18n';

interface Items {
  label: string;
  value: number;
  color: string;
}

interface Props {
  items: Items[];
}

const props = defineProps<Props>();

const { t } = useI18n();

// คำนวณผลรวมของ value (items เป็น undefined ได้ เช่น RADAR + extra-right-total ที่ hook ไม่ส่ง props มา)
const totalValue = computed(() => {
  return (props.items ?? []).reduce((sum, item) => sum + item.value, 0);
});
</script>

<style lang="scss" scoped>
.extra-right-legend {
  display: flex;
  align-items: center;
  height: 100%;
  // กราฟต้องไม่ถูกบีบ (ดู .chart-content-slot ใน custom-chart-container.scss) — legend เป็นฝ่ายหดแทนเมื่อพื้นที่ไม่พอ
  flex: 0 1 auto;
  min-width: 40px; // เพดานล่าง กันไม่ให้ legend หายไปทั้งหมด
  max-width: 130px; // เพดานบน ไม่ให้เบียดพื้นที่กราฟ
  overflow: hidden; // กันชั้นสุดท้ายไม่ให้เนื้อหาดันความกว้างเกิน max-width

  .extra {
    display: flex;
    flex-wrap: wrap; // พื้นที่แคบให้ตัวเลขตกบรรทัดใหม่แทนโดนตัด
    justify-content: center;
    align-items: center;
    gap: 4px 15px;
    text-align: center;
    min-width: 0; // จำเป็น: กันตัวเลขยาวดันความกว้างเกิน max-width ของ parent

    .total-title {
      font-size: 17px;
      color: #7e7e7e;
      overflow-wrap: anywhere;
    }
    .total {
      font-size: 25px;
      overflow-wrap: anywhere;
    }
  }
}
</style>
